import styled from 'styled-components';
import { palette } from '@seeneco-ui/core/styles';


const Title = styled.div`
	font-size: 12px;
	color: #8c8c8c;
`;

const Text = styled.div`
	display: flex;
	align-items: center;
	height: 29px;
	font-size: 14px;
	font-weight: 700;
`;

const Value = styled.td`
	padding: 0;
	padding-right: 35px;
	min-width: 150px;
`;

const Input = styled.textarea`
	width: 250px;
	height: 100px;
	margin-right: 12px;
	border: 3px solid ${palette.accentPrimary};
	border-radius: 6px;
	resize: none;
	outline: none;
`;

const Table = styled.table`
	border-spacing: 0;
	padding-top: "19px";
`;

export {
	Text,
	Title,
	Value,
	Input,
	Table,
};
